import { render, staticRenderFns } from "./vuecode.vue?vue&type=template&id=672bcc80&scoped=true"
import script from "./vuecode.vue?vue&type=script&lang=js"
export * from "./vuecode.vue?vue&type=script&lang=js"
import style0 from "./vuecode.vue?vue&type=style&index=0&id=672bcc80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672bcc80",
  null
  
)

export default component.exports